import api from '@/lib/axios';

export interface FileReference {
  id: string;
  fileName: string;
  contentType: string;
  size: number;
  objectType?: string;
  objectId?: string;
  workflow?: string;
  url: string;
  /**
   * Bucket-prefixed GCS object path, e.g. `/wp-test-public-files-dev-1/general/<fileId>`.
   * Present only for files in the public bucket (PROFILE_IMAGE workflow always lands
   * in the public bucket). Used as the `path` body field on the platform-service
   * profile-image PUT endpoints — FE posts unchanged, no client-side string assembly.
   */
  bucketPath?: string;
  createdAt: string;
}

export interface BatchUploadResponse {
  files: FileReference[];
  errors: Array<{ fileName: string; error: string }>;
}

const BASE = '/file-management-service/v1/files';

export const uploadFile = async (
  file: File,
  metadata?: { objectType?: string; objectId?: string; workflow?: string },
): Promise<FileReference> => {
  const formData = new FormData();
  formData.append('file', file);
  if (metadata?.objectType) formData.append('objectType', metadata.objectType);
  if (metadata?.objectId) formData.append('objectId', metadata.objectId);
  if (metadata?.workflow) formData.append('workflow', metadata.workflow);
  const { data } = await api.post<FileReference>(BASE, formData);
  return data;
};

export const uploadFiles = async (
  files: File[],
  metadata?: { objectType?: string; objectId?: string },
): Promise<BatchUploadResponse> => {
  const formData = new FormData();
  files.forEach((f) => formData.append('files[]', f));
  if (metadata?.objectType) formData.append('objectType', metadata.objectType);
  if (metadata?.objectId) formData.append('objectId', metadata.objectId);
  const { data } = await api.post<BatchUploadResponse>(`${BASE}/batch`, formData);
  return data;
};

export const getFileUrl = (fileId: string): string =>
  `/api/file-management-service/v1/files/${fileId}`;

export const deleteFile = async (fileId: string): Promise<void> => {
  await api.delete(`${BASE}/${fileId}`);
};
